var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewlogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2362 15.3599C26.2362 15.6344 26.1163 15.8951 25.9079 16.0737L22.6174 18.8941C22.4402 19.0461 22.2226 19.1204 22.006 19.1204C21.7411 19.1204 21.4776 19.0089 21.2917 18.7922C20.9538 18.3979 20.9993 17.8043 21.3936 17.4665L22.7545 16.3H14.9544C14.4353 16.3 14.0143 15.8791 14.0143 15.3599C14.0143 14.8407 14.4353 14.4197 14.9544 14.4197H22.7545L21.3936 13.2533C20.9993 12.9154 20.9538 12.3219 21.2917 11.9275C21.63 11.5337 22.224 11.4882 22.6174 11.8256L25.9079 14.646C26.1163 14.8246 26.2362 15.0854 26.2362 15.3599ZM17.7749 21.9409C17.7749 22.9779 16.9316 23.8212 15.8946 23.8212H10.2537C9.21696 23.8212 8.37345 22.9779 8.37345 21.9409V8.77888C8.37345 7.74188 9.21696 6.8986 10.2537 6.8986H15.8946C16.9316 6.8986 17.7749 7.74188 17.7749 8.77888V13.0095H19.6552V8.77888C19.6552 6.70533 17.9681 5.01831 15.8946 5.01831H10.2537C8.18019 5.01831 6.49316 6.70533 6.49316 8.77888V21.9409C6.49316 24.0144 8.18019 25.7014 10.2537 25.7014H15.8946C17.9681 25.7014 19.6552 24.0144 19.6552 21.9409V17.7102H17.7749V21.9409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogout);
export default __webpack_public_path__ + "static/media/newlogout.2468c0b23f089314c3e96e6d9b2eae1c.svg";
export { ForwardRef as ReactComponent };